document.addEventListener("DOMContentLoaded", function () {
    if (document.getElementById("wpadminbar")) {
        document.body.classList.add("admin-bar");
    }
});
   